
// Footer. js

import React from 'react'
import { Link } from 'react-router-dom';
import '../../styles/navigation/Footer.css';

import TextField from '../text/TextField';
import TitleField from '../text/TitleField';

import { FaLinkedin } from "react-icons/fa";

import { useMediaQuery } from '../../hooks/useMediaQuery';
import Reveal from '../motion/Reveal';

const Footer = () => {

    // The floating reCAPTCHA badge is hidden on mobile (see Footer.css —
    // it sits right on top of the Legal/Privacy/Terms links there). Google's
    // terms require the disclosure text below to be shown in its place.
    const isMobileViewport = useMediaQuery('(max-width: 767px)');

    const year = new Date().getFullYear();
    const footerText = `© ${year} NicheWare Solutions. All rights reserved.`;

    return (
        <div className='Footer-Container'>
            <Reveal as="div" className='Footer-Content' y={16} amount={0.1}>
                <div className='Footer-General-Nav-Container'>
                
                    <div className='Footer-Products-Container'>
                        
                        <div className='Footer-Products-Title-Container'>
                            <TitleField title="PRODUCTS" bold={true} fontSize="0.8rem" />
                        </div>
                        
                        <div className='Footer-Products-Text-Container'>
                            <Link to="/products#boathouse-rentee-app" className="Footer-Link">
                                <TextField text="Boathouse Rentee App" fontSize="0.95rem" bold={true} fontColor="#ffffff" />
                            </Link>

                            <Link to="/products#boathouse-renter-app" className="Footer-Link">
                                <TextField text="Boathouse Renter App" fontSize="0.95rem" bold={true} fontColor="#ffffff" />
                            </Link>

                            <Link to="/products#nichewallet" className="Footer-Link">
                                <TextField text="NicheWallet" fontSize="0.95rem" bold={true} fontColor="#ffffff" />
                            </Link>
                        </div>
                        
                    </div>
                        
                    <div className='Footer-Explore-Container'>
                        
                        <div className='Footer-Explore-Title-Container'>
                            <TitleField title="EXPLORE" bold={true} fontSize="0.8rem" />
                        </div>
                        
                        <div className='Footer-Explore-Text-Container'>
                            <Link to="/home" className="Footer-Link">
                                <TextField text="Home" fontSize="0.95rem" bold={true} fontColor="#ffffff" />
                            </Link>

                            <Link to="/products" className="Footer-Link">
                                <TextField text="Products" fontSize="0.95rem" bold={true} fontColor="#ffffff" />
                            </Link>

                            <Link to="/team" className="Footer-Link">
                                <TextField text="Team" fontSize="0.95rem" bold={true} fontColor="#ffffff" />
                            </Link>

                            <Link to="/contact" className="Footer-Link">
                                <TextField text="Contact Us" fontSize="0.95rem" bold={true} fontColor="#ffffff" />
                            </Link>
                        </div>
                        
                        
                    </div>

                    <div className='Footer-Clients-Container'>
                        
                        <div className='Footer-Clients-Title-Container'>
                            <TitleField title="CLIENTS" bold={true} fontSize="0.8rem" />
                        </div>
                        
                        <div className='Footer-Clients-Text-Container'>
                            <a href="https://auburnbayra.ca/" target="_blank" rel="noopener noreferrer" className="Footer-Link">
                                <TextField text="Auburn Bay Residents Association" fontSize="0.95rem" bold={true} fontColor="#ffffff" />
                            </a>

                            <a href="https://www.mlra.ca/" target="_blank" rel="noopener noreferrer" className="Footer-Link">
                                <TextField text="Mackenzie Lake Residents Association" fontSize="0.95rem" bold={true} fontColor="#ffffff" />
                            </a>

                            {/* // Currently not a client but almost for now we comment it out */}
                            {/* <a href="https://harmonyowners.com/" target="_blank" rel="noopener noreferrer" className="Footer-Link">
                                <TextField text="Harmony Owners Association" fontSize="0.95rem" bold={true} fontColor="#ffffff" />
                            </a> */}
                        </div>
                        
                    </div>


                    <div className='Footer-Developers-Container'>

                            <div className='Footer-Developers-Title-Container'>
                                <TitleField title="CONTACT" bold={true} fontSize="0.8rem" />
                            </div>
                            
                            <div className='Footer-Developers-Text-Container'>
                                <a href="https://www.linkedin.com/in/jeannicolasrouette/" target="_blank" rel="noopener noreferrer" className="Footer-Link">
                                    <TextField text="Jean-Nicolas Rouette" fontSize="0.95rem" bold={true} fontColor="#ffffff" />
                                </a>

                                <a href="https://www.linkedin.com/in/jad-khalil107/" target="_blank" rel="noopener noreferrer" className="Footer-Link">
                                    <TextField text="Jad Khalil" fontSize="0.95rem" bold={true} fontColor="#ffffff" />
                                </a>
                            </div>
                            

                    </div>
                </div>

                <div className='Footer-General-Socials-Container'>

                    <div className='Footer-Socials-Container'>
                        <a href="https://www.linkedin.com/company/nicheware-solutions/" target="_blank" rel="noopener noreferrer">
                            <FaLinkedin className="Footer-Linkedin-Icon" />
                        </a>
                    </div>

                </div>

                <div className='Footer-Copyright-Container'>
                    {/* copy right and status stuff */}
                    
                    <div className='Footer-Copyright-Text-Container'>
                        <TextField text={footerText} fontSize="0.75rem" fontColor="#8b929b" />
                    </div>
                    

                    <div className='Footer-Legal-Container'>
                        <Link to="/legal" className="Footer-Link">
                            <TextField text="Legal" fontSize="0.75rem" fontColor="#8b929b" />
                        </Link>

                        <Link to="/legal/privacy-policy" className="Footer-Link">
                            <TextField text="Privacy" fontSize="0.75rem" fontColor="#8b929b" />
                        </Link>

                         <Link to="/legal/terms-of-service" className="Footer-Link">
                            <TextField text="Terms" fontSize="0.75rem" fontColor="#8b929b" />
                        </Link>
                    </div>


                </div>

                {isMobileViewport && (
                    <div className='Footer-Recaptcha-Notice'>
                        <TextField fontSize="0.7rem" fontColor="#8b929b">
                            This site is protected by reCAPTCHA and the Google{" "}
                            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                                Privacy Policy
                            </a>{" "}
                            and{" "}
                            <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">
                                Terms of Service
                            </a>{" "}
                            apply.
                        </TextField>
                    </div>
                )}
            </Reveal>
        </div>
    )
}

export default Footer
